export default __webpack_public_path__ + "static/media/14.43fbd073.png";